import script from "./index.vue?vue&type=script&setup=true&name=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=ad6a7104&lang=scss"

const __exports__ = script;

export default __exports__